module.exports = __webpack_public_path__ + "img/Ritter.7385e9e8.svg";